import { Component } from '@angular/core';

@Component({
    selector: 'app-daily-feedback',
    templateUrl: './daily-feedback.component.html',
    styleUrls: ['./daily-feedback.component.scss'],
})
export class DailyFeedbackComponent {}
